import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94ff3776"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-cost-col" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("col", { span: "3" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("col", { class: "table-cost-col" }, null, -1))
const _hoisted_4 = { class: "table-example--slots slots-body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  style: {"text-align":"right"},
  class: "pr-3"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Total")
], -1))
const _hoisted_6 = {
  colspan: "1",
  style: {"text-align":"center"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "1" }, null, -1))

import { NotifiUser } from "@/models/NotifiUser";
import { SummaryItemLink, UserSummaryItem } from "@/notifi_types";
import { load } from "dotenv";
import Moralis from "moralis";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  props: {
  balance: { type: Number, required: true },
},
  setup(__props) {

const props = __props

const route = useRoute();

/* global defineProps, defineEmits */


//const user: NotifiUser | undefined = inject("NotifiUser");
const initialItems = [] as UserSummaryItem[];
const items = ref<UserSummaryItem[]>(initialItems);
const loading = ref(true);
const columns = ref([
  { key: "status" },
  { key: "detail" },
  { key: "name" },
  { key: "tokenCost", alignHead: "center", align: "center", sortable: "false" },
  {
    key: "runningTotal",
    alignHead: "center",
    align: "center",
    sortable: "false",
  },
  { key: "relatedItem" },
]);

const fetchItems = async () => {
  const us = Moralis.User.current();
  loading.value = true;
  if (us) {
    const u = new NotifiUser({ id: us.id });
    const newItems = await u.getCostSummaryItems();
    items.value.length = 0;
    items.value.push(...newItems);
    prioritySort();
    updateTotals();
  }
  loading.value = false;
};

const sorter = (first: UserSummaryItem, second: UserSummaryItem): number => {
  // Channels always go before other cost Types
  if (first.type == "Channel" && second.type != "Channel") return -1;
  if (second.type == "Channel" && first.type != "Channel") return 1;
  if (second.type == "Channel" && first.type == "Channel") {
    // Sort by the cheapest channels first. Free Channels are always enabled this way.
    return first.tokenCost - second.tokenCost;
  }
  // Finally, sort by Priority for Subscriptions so users can adjust if needed.
  return (first.costPriority || 0) - (second.costPriority || 0);
};

const prioritySort = () => {
  items.value.sort(sorter);
};

const updateTotals = () => {
  let cost = 0;
  for (let i = 0; i < items.value.length; i++) {
    const item: UserSummaryItem = items.value[i];
    cost = cost + item.tokenCost;
    item.runningTotal = cost;
    if (cost > props.balance) {
      item.status = "Over Balance";
      item.color = "danger";
    }
  }
};

const total = computed((): number => {
  let sum = 0;
  items.value.forEach((i) => {
    sum = sum + i.tokenCost;
  });
  return sum;
});

const overCost = (source: any) => {
  return source > props.balance;
};
const overCostIndex = (idx: number): boolean => {
  const rec = items.value[idx];
  return (rec.runningTotal || 0) > props.balance;
};
const moveDown = (idx: number): void => {
  const rec: UserSummaryItem = items.value[idx];
  rec.costPriority = (rec.costPriority || 0) - 1;
  prioritySort();
};
const moveUp = (idx: number): void => {
  const rec = items.value[idx];
  rec.costPriority = (rec.costPriority || 0) + 1;
  prioritySort();
};

onMounted(async () => {
  await fetchItems();
});

const itemPath = (relatedItem: SummaryItemLink) => {
  const returnPath = route.path;
  return `${relatedItem.url}?returnPath=${returnPath}`;
};

return (_ctx: any,_cache: any) => {
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_data_table = _resolveComponent("va-data-table")!

  return (_openBlock(), _createBlock(_component_va_data_table, {
    hoverable: "",
    items: items.value,
    loading: loading.value,
    columns: columns.value
  }, {
    "cell(relatedItem)": _withCtx(({ source: relatedItem }) => [
      _createVNode(_component_va_chip, {
        to: itemPath(relatedItem)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(relatedItem.className), 1)
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    "cell(tokenCost)": _withCtx(({ source: tokenCost }) => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(tokenCost), 1)
    ]),
    "cell(status)": _withCtx(({ rowIndex, value }) => [
      _createVNode(_component_va_popover, {
        color: "danger",
        message: "Item will be deactived - add Notifi"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_va_icon, {
            color: "danger",
            size: 20,
            name: "warning_amber"
          }, null, 512), [
            [_vShow, overCostIndex(rowIndex)]
          ])
        ]),
        _: 2
      }, 1024),
      _createElementVNode("span", {
        class: _normalizeClass({ 'over-cost': overCostIndex(rowIndex) })
      }, _toDisplayString(value), 3)
    ]),
    "cell(runningTotal)": _withCtx(({ source, value, rowIndex }) => [
      _createElementVNode("span", {
        class: _normalizeClass(["table-cost-col", { 'over-cost': overCost(source) }])
      }, _toDisplayString(value), 3),
      _withDirectives(_createVNode(_component_va_icon, {
        name: "arrow_drop_up",
        size: "small",
        onClick: ($event: any) => (moveUp(rowIndex))
      }, null, 8, ["onClick"]), [
        [_vShow, false]
      ]),
      _withDirectives(_createVNode(_component_va_icon, {
        name: "arrow_drop_down",
        size: "small",
        onClick: ($event: any) => (moveDown(rowIndex))
      }, null, 8, ["onClick"]), [
        [_vShow, false]
      ])
    ]),
    colgroup: _withCtx(() => [
      _hoisted_2,
      _hoisted_3
    ]),
    bodyAppend: _withCtx(() => [
      _withDirectives(_createElementVNode("tr", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("td", _hoisted_6, [
          _createElementVNode("strong", null, _toDisplayString(_unref(total)), 1)
        ]),
        _hoisted_7
      ], 512), [
        [_vShow, items.value.length > 0]
      ])
    ]),
    _: 1
  }, 8, ["items", "loading", "columns"]))
}
}

})